import { OrganizationProjectOverview } from "@/src/features/organizations/components/ProjectOverview";

export default function Home() {
  return <OrganizationProjectOverview />;
}
